import { render, staticRenderFns } from "./SummaryIncomeSources.vue?vue&type=template&id=34b8ef66&"
import script from "./SummaryIncomeSources.vue?vue&type=script&lang=js&"
export * from "./SummaryIncomeSources.vue?vue&type=script&lang=js&"
import style0 from "./SummaryIncomeSources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports